import ContractModalFooter from './ContractModalFooter';

export default ContractModalFooter;
